<mat-card>
  <mat-card-title>Update Field</mat-card-title>
  <form class="matrix-form" [formGroup]="config" (ngSubmit)="saveField()">
    <div class="form-field">
      <label for="alias">Alias:</label>
      <input #firstInput id="alias" autocomplete="off" type="text" name="alias" formControlName="alias" />
      @if (config.get('alias').errors?.required) {
        <div class="required">*</div>
      }
      <div class="validation-text">
        @if (config.get('alias').errors?.invalidAlias) {
          <span>{{invalidFormatMessage}}</span>
        }
      </div>
    </div>
    <div class="form-field">
      <label for="description">Description:</label>
      <textarea id="description" name="description" formControlName="description" rows="3">
      </textarea>
      @if (config.get('description').errors?.required) {
        <div class="required">*</div>
      }
      <div class="validation-text">
      </div>
    </div>
    <div class="form-field" [hidden]="!useScoreAndColour">
      <label>Colour:</label>
      <aw-colour-picker formControlName="colour" class="colourpicker"></aw-colour-picker>
      @if (config.get('colour').errors?.required) {
        <div class="required">*</div>
      }
      <div class="validation-text">
        @if (config.get('colour').errors?.required) {
          <span>This is Required</span>
        }
      </div>
    </div>
    <div class="form-field" [hidden]="!useScoreAndColour">
      <label for="score">Score:</label>
      <input class="mat-form-field" autocomplete="off" id="score" name="score" formControlName="score" type="number">
      <div class="validation-text">
        @if (config.get('score').errors?.pattern) {
          <span>Whole numbers only</span>
        }
      </div>
    </div>
    <div class="form-field" [hidden]="!useScoreAndColour || !isSeverityMatrix">
      <label for="includedInQuery">Include In Query:</label>
      <mat-checkbox id="includedInQuery" name="includedInQuery" formControlName="includedInQuery"></mat-checkbox>
    </div>
    <div class="buttons">
      <button mat-raised-button color="warn" type="button" (click)="cancel()">Cancel</button>
      <button mat-raised-button color="accent" type="submit">Save</button>
    </div>
  </form>
</mat-card>